'use client'

import React, { useEffect } from 'react'
import cl from 'clsx'
import Image from 'next/image'
import close from '@/public/icons/close.svg'
import styles from './styles.module.css'

const Modal = ({ isOpen, onClose, children, type }) => {
    useEffect(() => {
        const lockScroll = () => {
            const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollBarWidth}px`;
        };

        const unlockScroll = () => {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };

        if (isOpen) {
            lockScroll();
        } else {
            unlockScroll();
        }

        return () => unlockScroll();
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div id="modal-overlay" className={styles.modal}>
            <div
                className={cl(
                    styles.modal__content,
                    type === 'quiz' && styles.modal__content_quiz,
                    type === 'contact-form-main' && styles.modal__content_contact_form_main,
                    type === 'create-user' && styles.modal__content_create,
                    type === 'log-in' && styles.modal__content_login,
                    type === 'testimonials' && styles.modal__content_testimonials
                )}
            >
                <button onClick={onClose} className={styles.modal__close_btn}>
                    <Image
                        src={close}
                        className={styles.modal__close}
                        alt="close"
                        width={20}
                        height={20}
                    />
                </button>
                {children}
            </div>
        </div>
    );
};

export default Modal;
